import { adPlatformSettingsByClient } from './reducers';

import * as adPlatformSettingsByClientOperations from './operations';

export { adPlatformSettingsByClient, adPlatformSettingsByClientOperations };
